import React, { useEffect, useRef, useState } from "react";
import { Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchBankBranch,
  fetchItem, 
} from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";


const { TextArea } = Input;

const AddStaffExemptsModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { itemb, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const { personnelFolders } = useSelector((state) => state.folder);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.ppId) {
      toast.error("Please select personnel");
      return;
    }
    if (!formData?.seItemcode) {
      toast.error("Please select item");
      return;
    }
    
    const res = await dispatch(
      save({
        seId: prodd?.seId ? prodd?.seId : null,
        ppId: formData?.ppId,
        seItemcode: formData?.seItemcode,
        
        url: "hr/saveStaffExempt.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchPersonnelData(page, size) {
    dispatch(fetchPersonnelFolders());
  }
  async function fetchItemData(page, size) {
    dispatch(fetchItem());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.jbnkShtDesc}` : "Add staff exempt details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label={<span>Staff</span>}
            rules={[
              {
                required: true,
                message: "Please select staff",
              },
            ]}
          >
            <Select
              name="ppId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                personnelFolders?.length > 0 &&
                personnelFolders?.map((item) => ({
                  value: item?.ppId,
                  label: item?.ppPfno + " - " + item?.ppFullname,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ppId");
              }}
              value={formData?.ppId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchPersonnelData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Item</span>}
            rules={[
              {
                required: true,
                message: "Please select item",
              },
            ]}
          >
            <Select
              name="seItemcode"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                itemb?.length > 0 &&
                itemb?.map((item) => ({
                  value: item?.piItemcode,
                  label: item?.piItemcode + " - " + item?.piItemname,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "seItemcode");
              }}
              value={formData?.seItemcode}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchItemData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

           

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddStaffExemptsModal;
